import React from "react";
import classNames from "classnames";

const MainWrapper = ({ children, className }) => {
  return (
    <div className={classNames("position-relative w-100 d-flex", className)}>
      {children}
    </div>
  );
};

export default MainWrapper;
